export default [
    {
        title: 'General purpose',
        data: ['default', 'none'],
    },
    {
        title: 'Status',
        data: ['help', 'pointer', 'progress', 'wait', 'context-menu', 'not-allowed'],
    },
    {
        title: 'Selection',
        data: ['cell', 'crosshair', 'text', 'vertical-text'],
    },
    { title: 'Zoom', data: ['zoom-in', 'zoom-out'] },
    { title: "Drag'n'Drop", data: ['alias', 'copy', 'move', 'no-drop', 'grab', 'grabbing'] },
    {
        title: 'Resize and scroll',
        data: [
            'all-scroll',
            'col-resize',
            'row-resize',
            'n-resize',
            'e-resize',
            's-resize',
            'w-resize',
            'ns-resize',
            'ew-resize',
            'ne-resize',
            'nw-resize',
            'se-resize',
            'sw-resize',
            'nesw-resize',
            'nwse-resize',
        ],
    },
];
